export default "__VITE_ASSET__BQz7We7F__"